export class ScheduleRowColumnVisibility {
  private _unadjObsDate: boolean = true;
  private _adjObsDate: boolean = true;
  private _accrualStartDate: boolean = true;
  private _accrualEndDate: boolean = true;
  private _unadjPmtDate: boolean = true;
  private _adjPmtDate: boolean = true;
  private _callNoticeDate: boolean;
  private _rateDeterminationDate: boolean;
  private _barrierLevel: boolean;
  private _redemptionAmountPayable_relative: boolean;
  private _rangeAccrualRate: boolean;
  private _lowerLevel: boolean;
  private _upperLevel: boolean;

  constructor() {}

  public static fromValues(values: any): ScheduleRowColumnVisibility {
    const visibility = new ScheduleRowColumnVisibility();
    Object.keys(values)?.forEach((key: string) => {
      visibility[key] = values[key];
    });
    return visibility;
  }

  get barrierLevel(): boolean {
    return this._barrierLevel;
  }

  get unadjObsDate(): boolean {
    return this._unadjObsDate;
  }

  get adjObsDate(): boolean {
    return this._adjObsDate;
  }

  get accrualStartDate(): boolean {
    return this._accrualStartDate;
  }

  get accrualEndDate(): boolean {
    return this._accrualEndDate;
  }

  get unadjPmtDate(): boolean {
    return this._unadjPmtDate;
  }

  get adjPmtDate(): boolean {
    return this._adjPmtDate;
  }

  get rateDeterminationDate(): boolean {
    return this._rateDeterminationDate;
  }

  get callNoticeDate(): boolean {
    return this._callNoticeDate;
  }

  get redemptionAmountPayable_relative(): boolean {
    return this._redemptionAmountPayable_relative;
  }

  get rangeAccrualRate(): boolean {
    return this._rangeAccrualRate;
  }

  get lowerLevel(): boolean {
    return this._lowerLevel;
  }

  get upperLevel(): boolean {
    return this._upperLevel;
  }

  set callNoticeDate(value: boolean) {
    this._callNoticeDate = value;
  }

  set barrierLevel(value: boolean) {
    this._barrierLevel = value;
  }

  set redemptionAmountPayable_relative(value: boolean) {
    this._redemptionAmountPayable_relative = value;
  }

  set unadjObsDate(value: boolean) {
    this._unadjObsDate = value;
  }

  set adjObsDate(value: boolean) {
    this._adjObsDate = value;
  }

  set accrualStartDate(value: boolean) {
    this._accrualStartDate = value;
  }

  set accrualEndDate(value: boolean) {
    this._accrualEndDate = value;
  }

  set unadjPmtDate(value: boolean) {
    this._unadjPmtDate = value;
  }

  set adjPmtDate(value: boolean) {
    this._adjPmtDate = value;
  }

  set rateDeterminationDate(value: boolean) {
    this._rateDeterminationDate = value;
  }

  set rangeAccrualRate(value: boolean) {
    this._rangeAccrualRate = value;
  }

  set lowerLevel(value: boolean) {
    this._lowerLevel = value;
  }

  set upperLevel(value: boolean) {
    this._upperLevel = value;
  }
}
